module.exports = __webpack_public_path__ + "static/media/brands_ARVEK.68b26b28.svg";